import classnames from 'classnames/bind'
import { FC } from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface CellProps {
  value: string | number
  bold?: boolean
}

const Cell: FC<CellProps> = ({ value }) => {
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Label11Haffer,
  })

  return <td className={cx(css.cell, textStyle)}>{value}</td>
}

export default Cell
